import { j as l } from "./jsx-runtime-e6RZPHeG.js";
import { memo as c } from "react";
const i = ({
  title: e,
  titleId: o,
  ...s
}) => /* @__PURE__ */ l.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...s,
    children: [
      e ? /* @__PURE__ */ l.jsx("title", { id: o, children: e }) : null,
      /* @__PURE__ */ l.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "m699.563 684.587-14.976 14.955c-5.803 5.805-13.821 9.396-22.677 9.396s-16.874-3.591-22.677-9.396L512.044 572.353 384.791 699.606c-5.787 5.788-13.782 9.367-22.613 9.367s-16.826-3.58-22.613-9.367l-15.189-15.211c-5.776-5.772-9.349-13.749-9.349-22.56 0-8.79 3.556-16.749 9.308-22.518L451.14 512.022 324.399 384.79c-5.763-5.786-9.327-13.768-9.327-22.581 0-8.835 3.58-16.834 9.369-22.624l15.147-15.147c5.807-5.813 13.833-9.409 22.699-9.409 8.812 0 16.795 3.553 22.594 9.304l-.002-.002L512.58 451.158l126.699-126.699c5.792-5.795 13.794-9.38 22.635-9.38s16.843 3.585 22.634 9.38l15.083 15.083c5.789 5.791 9.369 13.789 9.369 22.624s-3.58 16.833-9.369 22.624L572.399 512.022l127.147 127.189c5.81 5.801 9.405 13.819 9.405 22.677s-3.594 16.877-9.404 22.677zM512 64C264.533 64 64 264.533 64 512s200.533 448 448 448 448-200.533 448-448S759.467 64 512 64m0 42.667c223.509 0 405.333 181.824 405.333 405.333S735.509 917.333 512 917.333 106.667 735.509 106.667 512 288.491 106.667 512 106.667",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = c(i);
export {
  n as default
};
